// extracted by mini-css-extract-plugin
module.exports = {"btn-like":"btn-like","is-like":"is-like","icon":"icon"};